export const ADDTOCART_REQUEST="ADDTOCART_REQUEST";
export const ADDTOCART_SUCCESS="ADDTOCART_SUCCESS";
export const ADDTOCART_FAILURE="ADDTOCART_FAILURE";

export const GETCART_REQUEST="GETCART_REQUEST";
export const GETCART_SUCCESS="GETCART_SUCCESS";
export const GETCART_FAILURE="GETCART_FAILURE";

export const DELETE_CARTDATA_REQUEST="DELETECARTDATA_REQUEST";
export const DELETE_CARTDATA_SUCCESS="DELETECARTDATA_SUCCESS";
export const DELETE_CARTDATA_FAILURE="DELETECARTDATA_FAILURE";